<template>
    <div id="newsletter-form"></div>
</template>
<script>
import {
  FCol
} from "faaren-ui";

export default {
  name: "NewsLetterModal",
  components: {
    FCol
  },
  mounted() {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js";
    document.body.appendChild(script);
    script.addEventListener("load", () => {

      if (window.hbspt) {
        console.log("hubspot", window.hbspt.forms)
        window.hbspt.forms.create({
          portalId: "5264255",
          formId: "d6d77e6b-a287-4d0d-9757-c85a28173494",
          target: "#newsletter-form"
        })
      }
    })
  }
}
</script>
<style lang="scss">
  .border-box {
    border-left: 0.1px groove white;
    height: 80%;
  }
</style>
